export const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const dd = String(date.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const mmm = monthNames[date.getMonth()] || '';
  const yyyy = date.getFullYear();
  return `${dd}-${mmm}-${yyyy}`;
};

export const formatDateTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const dd = String(date.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const mmm = monthNames[date.getMonth()] || '';
  const yyyy = date.getFullYear();
  const hours24 = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours24 >= 12 ? 'PM' : 'AM';
  const hours12 = String(hours24 % 12 === 0 ? 12 : hours24 % 12).padStart(2, '0');
  return `${dd}-${mmm}-${yyyy} ${hours12}:${minutes} ${ampm}`;
};

export const truncateWithEllipsis = (value, size = 24) => {
  if (!value) return '';
  return value.length > size ? `${value.slice(0, size)}...` : value;
};

export const approvalStatusLabel = (value) => {
  const numericStatus = Number(value);
  if (numericStatus === 1) return 'Approved';
  if (numericStatus === 2) return 'Rejected';
  return 'Open';
};

export const requestStatusLabel = (value) => (Number(value) === 1 ? 'Closed' : 'Open');

export const exportToCsv = (rows, fileName = 'staffing-request-report.csv') => {
  if (!rows?.length) return;

  const headers = [
    '#',
    'SRN#',
    'Requested By',
    'Requested Date',
    'Project Name',
    'Project Vertical',
    'No.of Resources',
    'Experience',
    'Allocated Resources',
    'Allocation %',
    'Role',
    'Mandatory Skills',
    'Good to have Skills',
    'Start Date',
    'End Date',
    'Remarks',
    'Approvers',
    'Approval Status',
    'Approval By',
    'Approval Date',
    'Approval Remarks',
    'Request Status',
    'Request Status Changed Date',
    'Request Remarks',
  ];

  const escaped = (cell) => {
    const value = cell ?? '';
    const normalized = String(value).replaceAll('"', '""');
    return `"${normalized}"`;
  };

  const lines = rows.map((row, index) => [
    index + 1,
    row.sr_number,
    row.submit_by,
    formatDate(row.submit_date),
    row.project_name,
    row.vertical || row.project_vertical,
    row.resource_no,
    row.experience,
    row.allocated_res,
    row.allocation_per,
    row.resource_type_name,
    row.skills,
    row.good_skills,
    formatDate(row.start_date),
    formatDate(row.end_date),
    row.remarks,
    row.approvers,
    approvalStatusLabel(row.is_approved),
    row.approved_by,
    formatDate(row.approved_date),
    row.approved_remarks,
    requestStatusLabel(row.is_close),
    formatDate(row.close_date),
    row.close_remarks,
  ].map(escaped).join(','));

  const csv = [headers.map(escaped).join(','), ...lines].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchorElement = document.createElement('a');
  anchorElement.href = url;
  anchorElement.download = fileName;
  anchorElement.click();
  URL.revokeObjectURL(url);
};
